export enum ConsoleEnum {
  Xbox = 1,
  Playstation = 2,
  PC = 3,
  Nintendo = 4,
  Android = 5,
  iOS = 6,
}
